<template>
  <div class="vmdtp_body">
    <ul class="vmdtp_head">
      <li
        v-for="(day, index) in name"
        :key="`${day}-${index}`"
        class="vmdtp_head__item"
      >
        {{ day }}
      </li>
    </ul>
    <ul class="vmdtp_main">
      <li
        v-for="(obj, index) in days"
        :key="`${obj.day}-${index}`"
        :class="{disabled: obj.disabled}"
        class="vmdtp_main__item"
        @click.prevent="handleClick(obj.day)"
      >
        <span :class="{ selected: (obj.day === selectedDay)}">
          {{ obj.day }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Day',
  props: {
    name: {
      type: Array,
      required: true
    },
    number: {
      type: Number,
      required: true
    },
    position: {
      type: Number,
      required: true
    },
    selectedDay: {
      type: Number,
      required: true
    },
    selectedYear: {
      type: Number,
      required: true
    },
    selectedMoth: {
      type: Number,
      required: true
    },
    disabledDates: {
      type: Array | Object,
      required: false
    },
    disabledDatesAndTimes: {
      type: Array | Object,
      required: false
    }
  },
  methods: {
    handleClick (day) {
      this.$emit('day', day)
    }
  },
  computed: {
    days () {
      const disabled = this.disabledDates.length > 0 ? this.disabledDates : this.disabledDatesAndTimes
      const prevMonthDays = new Array(this.position).fill(null)
      const monthDays = Array.from({length: this.number}, (v, k) => k + 1)

      let filteredDates
      const dates = [...prevMonthDays, ...monthDays]

      filteredDates = dates.map(v => {
        let obj = { day: v }
        const dayDate = new Date(this.selectedYear, this.selectedMoth, v)
        disabled.forEach(o => {
          const toJSDate = o.to && new Date(o.to)
          const fromJSDate = o.from && new Date(o.from)
          if (o.to && !o.from && !obj.disabled) {
            obj.disabled = !(toJSDate.getTime() <= dayDate.getTime())
          } else if (!o.to && o.from && !obj.disabled) {
            obj.disabled = !(dayDate.getTime() <= fromJSDate.getTime())
          } else if (o.to && o.from && !obj.disabled) {
            obj.disabled = (fromJSDate.getTime() <= dayDate.getTime() && dayDate.getTime() <= toJSDate.getTime())
          } else if (!obj.disabled) {
            obj.disabled = false
          }
        })
        return obj
      })

      return filteredDates
    }
  }
}
</script>

<style scoped>
.vmdtp_body {
  height: 290px;
  overflow: auto;
  padding: 0 12px;
}
.vmdtp_head {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.vmdtp_head__item {
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  color: rgba(84, 84, 84, 0.5);
}
.vmdtp_main {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  margin: 0;
  padding: 0;
  list-style: none;
}
.vmdtp_main__item {
  margin: 8px 0;
  display: flex;
  justify-content: center;
  flex-basis: calc(100% / 7);
}
.vmdtp_main__item.disabled {
  pointer-events: none;
}
.vmdtp_main__item.disabled span {
  color: #e0e0e0;
}
.vmdtp_main__item span {
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  font-family: sans-serif;
  font-size: 12px;
  font-weight: 600;
  line-height: 22px;
  color: #545454;
  transition: all 0.25s ease-in-out;
}
.vmdtp_main__item span:hover {
  cursor: pointer;
  background-color: rgba(84, 84, 84, 0.1);
}
.vmdtp_main__item span.selected {
  background-color: #0e9bd4;
  color: #fff;
}
</style>
